/** user.services */
import axios from '@/axios/fetch';

/** 用户services */
const userServices = () => {
  /** 批量删除学生 */
  const delUserByIds = async (classId: string, stuIds: string[]) => {
    const data = await axios.post('./api/userHero/deleteStudents', {
      classId,
      codes: stuIds,
    });
    return data;
  };

  /** 删除教师 */
  const delTeacherByIds = async (teaIds: string[]) => {
    const data = await axios.post('./api/userHero/deleteTeachers', {
      codes: teaIds,
    });
    return data;
  };

  /** 删除班级 */
  const delClassById = async (id: string) => {
    const data = await axios.post(`./api/userHero/deleteByClassId/${id}`);
    return data;
  };
  return {
    delUserByIds,
    delTeacherByIds,
    delClassById,
  };
};

export default userServices;
